import { Formik, Form } from 'formik';
import {
    initialValues,
    validationSchema_18716,
} from 'blocks/Form/data/validation';
import FirstNameLastName from 'blocks/Form/fields/FirstNameLastName';
import Email from 'blocks/Form/fields/Email';
import Hospital from 'blocks/Form/fields/Hospital';
import Phone from 'blocks/Form/fields/Phone';
import Location from 'blocks/Form/fields/Location';
import InqueryType from 'blocks/Form/fields/InqueryType';
import MarketingRequested from 'blocks/Form/fields/MarketingRequested';
import Submit from 'blocks/Form/fields/Submit';
import Notes from 'blocks/Form/fields/Notes';
import Role from 'blocks/Form/fields/Role';
import Specialty from 'blocks/Form/fields/Specialty';
import ProductCategory from 'blocks/Form/fields/ProductCategory';
import ProductsOfInterestHCP from 'blocks/Form/fields/ProductsOfInterestHCP';
import TopicsOfInterestHCP from 'blocks/Form/fields/TopicsOfInterestHCP';
import CommunicationPreference from 'blocks/Form/fields/CommunicationPreference';

/* === CORP - Healthcare Professionals === */

const Form18716 = ({ handleSubmit, isPending, language, fields }) => {
    initialValues.Product_s_of_Interest__c = [];
    initialValues.Topics_Of_Interest__c = [];
    initialValues.Communication_Preference__pc = '';
    const {
        first_name,
        last_name,
        email_address,
        phone,
        hospital,
        location,
        what_are_you_looking_for_18716,
        product_category,
        role,
        specialty,
        communication_preference,
        products_of_interest_ahm,
        products_of_interest_hvr,
        products_of_interest_shv,
        products_of_interest_thv,
        products_of_interest_vs,
        topics_of_interest_general,
        notes,
        marketing_requested,
        submit,
        validation,
    } = fields;

    const ers_filter = what_are_you_looking_for_18716.options.filter(
        (item) => item.value !== 'Reimbursement'
    );

    const ers_what_are_you_looking_for_18716 = {
        ...what_are_you_looking_for_18716,
        options: ers_filter,
    };

    const main_languages = ['default', 'gb'];

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleSubmit('marketo', values)}
            validationSchema={validationSchema_18716(validation, language)}
        >
            {(formik) => (
                <Form className="form form--lg">
                    <div className="grid-lg-2 row-gap-0">
                        <FirstNameLastName
                            first_name={first_name}
                            last_name={last_name}
                            initialValues={initialValues}
                            language={language}
                        />
                        <Email
                            label={email_address}
                            initialValues={initialValues}
                        />
                        <Phone label={phone} initialValues={initialValues} />
                        <Hospital
                            label={hospital}
                            initialValues={initialValues}
                        />
                        {language !== 'kr' && (
                            <Location
                                data={location}
                                formik={formik}
                                initialValues={initialValues}
                            />
                        )}
                        <Role initialValues={initialValues} data={role} />
                        <Specialty
                            data={specialty}
                            initialValues={initialValues}
                        />
                        <InqueryType
                            data={
                                language === 'default' || language === 'ca-en'
                                    ? what_are_you_looking_for_18716
                                    : ers_what_are_you_looking_for_18716
                            }
                            initialValues={initialValues}
                        />
                        <ProductCategory
                            data={product_category}
                            initialValues={initialValues}
                            formik={formik}
                        />
                    </div>
                    {main_languages.includes(language) && (
                        <>
                            {formik.values.productCategory ===
                                'Heart Valve Repair' && (
                                <CommunicationPreference
                                    data={communication_preference}
                                    initialValues={initialValues}
                                />
                            )}
                            {(formik.values.productCategory ===
                                'Advanced Hemodynamic Monitoring' ||
                                formik.values.productCategory ===
                                    'Pressure Monitoring') && (
                                <ProductsOfInterestHCP
                                    initialValues={initialValues}
                                    data={products_of_interest_ahm}
                                />
                            )}
                            {formik.values.productCategory ===
                                'Heart Valve Repair' && (
                                <ProductsOfInterestHCP
                                    initialValues={initialValues}
                                    data={products_of_interest_hvr}
                                />
                            )}
                            {formik.values.productCategory ===
                                'Surgical Heart Valves' && (
                                <ProductsOfInterestHCP
                                    initialValues={initialValues}
                                    data={products_of_interest_shv}
                                />
                            )}
                            {formik.values.productCategory ===
                                'Transcatheter Heart Valves' && (
                                <ProductsOfInterestHCP
                                    initialValues={initialValues}
                                    data={products_of_interest_thv}
                                />
                            )}
                            {formik.values.productCategory ===
                                'Vascular Surgery' && (
                                <ProductsOfInterestHCP
                                    initialValues={initialValues}
                                    data={products_of_interest_vs}
                                />
                            )}
                            {(formik.values.productCategory ===
                                'Advanced Hemodynamic Monitoring' ||
                                formik.values.productCategory ===
                                    'Pressure Monitoring') && (
                                <TopicsOfInterestHCP
                                    initialValues={initialValues}
                                    data={topics_of_interest_general}
                                />
                            )}
                        </>
                    )}
                    <Notes label={notes} initialValues={initialValues} />
                    <MarketingRequested
                        formik={formik}
                        initialValues={initialValues}
                        data={marketing_requested}
                    />

                    <Submit
                        formik={formik}
                        isPending={isPending}
                        pendingText={submit.submitting}
                        validation={submit.all_required_fields}
                    >
                        {submit.contact_now}
                    </Submit>
                </Form>
            )}
        </Formik>
    );
};

export default Form18716;
